import {gql} from 'apollo-boost';

export const GET_DEGREES = gql`
  query getDegrees{
    getDegrees {
      id
      code
      nameLocal
      nameEng
      label
    }
  }
`;

export const GET_DEGREE = gql`
  query getDegree($id : ID!){
    getDegree (
      id: $id
    ) {
      id
      code
      nameLocal
      nameEng
      label
    }
  }
`;

export const ADD_DEGREE = gql`
  mutation addDegree(
    $code: String!,
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    addDegree(
      code: $code
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const UPDATE_DEGREE = gql`
  mutation updateDegree(
    $id: ID!,
    $code: String!,
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    updateDegree(
      id: $id
      code: $code
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const DELETE_DEGREE = gql`
  mutation deleteDegree($id: ID!) {
    deleteDegree(
      id: $id
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

